import React, { useState } from 'react';
import styled from 'styled-components';
import emailjs from '@emailjs/browser';
import { strings } from './strings';

const PageSection = styled.section`
  padding: 4rem 0;
  direction: rtl;
`;

const PageContainer = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const PageTitle = styled.h1`
  font-size: 2.25rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1.5rem;
  
  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 1.25rem;
  color: #374151;
  max-width: 48rem;
  margin: 0 auto;
`

const ContactPageGrid = styled.div`
  display: grid;
  gap: 3rem;
  
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;


const FormGrid = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const FormGroup = styled.div``;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
`;

const ContactInfo = styled.div``;

const ContactInfoTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const ContactIcon = styled.span`
  color: #ea580c;
  margin-top: 0.25rem;
  font-size: 1.25rem;
`;

const ContactDetails = styled.div``;

const ContactLabel = styled.h3`
  font-weight: 600;
  color: #111827;
`;

const ContactValue = styled.p`
  color: #374151;
`;

const BusinessHours = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #fff7ed;
  border-radius: 0.5rem;
`;

const BusinessHoursTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
`;

const HoursList = styled.div`
  font-size: 0.875rem;
  color: #374151;
`;

const HoursItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

// Add these new styled components for loading state and disabled inputs
const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-left: 0.5rem;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

// Update existing styled components to include disabled states
const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #ea580c;
    box-shadow: 0 0 0 2px rgba(234, 88, 12, 0.2);
  }
  
  &:disabled {
    background-color: #f9fafb;
    cursor: not-allowed;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.2s;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #ea580c;
    box-shadow: 0 0 0 2px rgba(234, 88, 12, 0.2);
  }
  
  &:disabled {
    background-color: #f9fafb;
    cursor: not-allowed;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background-color: #ea580c;
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover:not(:disabled) {
    background-color: #c2410c;
  }
  
  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`;

// Contact Page Component with EmailJS
const ContactPageComponent = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      alert('אנא מלא את כל השדות הנדרשים.');
      return;
    }

    setIsLoading(true);

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        from_phone: formData.phone || 'לא צוין',
        message: formData.message,
        to_email: 'haggaimagen87@gmail.com'
      };

      await emailjs.send(
        'service_w3pkjf6',      // Your service ID
        'template_lwf20nq',     // Your template ID
        templateParams,
        'Sgy1Do0paUmA8QyPR'     // Your public key
      );

      alert(`תודה ${formData.name}! ההודעה נשלחה בהצלחה. נחזור אליך בקרוב.`);
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('EmailJS Error:', error);
      alert('שגיאה בשליחת ההודעה. אנא נסה שוב או צור קשר טלפונית.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageSection>
      <PageContainer>
        <PageHeader>
          <PageTitle>צור קשר</PageTitle>
          <PageSubtitle>
            מוכן להתחיל את מסע השינוי שלך? אנחנו כאן כדי לענות על השאלות שלך ולעזור לך להתחיל.
          </PageSubtitle>
        </PageHeader>

        <ContactPageGrid>
          <div>
            <ContactInfoTitle>שלח לנו הודעה</ContactInfoTitle>
            <FormGrid>
              <FormGroup>
                <Label htmlFor="name">שם מלא *</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="email">כתובת אימייל *</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="phone">מספר טלפון</Label>
                <Input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="message">הודעה *</Label>
                <TextArea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  placeholder="ספר לנו על המטרות שלך ואיך אנחנו יכולים לעזור לך..."
                  disabled={isLoading}
                />
              </FormGroup>
              <SubmitButton onClick={handleSubmit} disabled={isLoading}>
                {isLoading ? (
                  <>
                    שולח הודעה...
                    <LoadingSpinner />
                  </>
                ) : (
                  'שלח הודעה'
                )}
              </SubmitButton>
            </FormGrid>
          </div>

          {/* Contact Info section remains the same */}
          <ContactInfo>
            <ContactInfoTitle>פרטי התקשרות</ContactInfoTitle>
            <div>
              <ContactItem>
                <ContactIcon>📞</ContactIcon>
                <ContactDetails>
                  <ContactLabel>טלפון</ContactLabel>
                  <ContactValue>{strings.contact.phone}</ContactValue>
                </ContactDetails>
              </ContactItem>
              <ContactItem>
                <ContactIcon>✉️</ContactIcon>
                <ContactDetails>
                  <ContactLabel>אימייל</ContactLabel>
                  <ContactValue>{strings.contact.email}</ContactValue>
                </ContactDetails>
              </ContactItem>
              <ContactItem>
                <ContactIcon>📍</ContactIcon>
                <ContactDetails>
                  <ContactLabel>מיקום</ContactLabel>
                  <ContactValue>{strings.contact.address1}</ContactValue>
                  <ContactValue>{strings.contact.address2}</ContactValue>
                </ContactDetails>
              </ContactItem>
            </div>

            <BusinessHours>
              <BusinessHoursTitle>שעות פעילות</BusinessHoursTitle>
              <HoursList>
                <HoursItem>
                  <span>ראשון - חמישי:</span>
                  <span>19:00 - 09:00</span>
                </HoursItem>
                <HoursItem>
                  <span>שישי:</span>
                  <span>15:00 - 09:00</span>
                </HoursItem>
              </HoursList>
            </BusinessHours>
          </ContactInfo>
        </ContactPageGrid>
      </PageContainer>
    </PageSection>
  );
};

export default ContactPageComponent;